module.exports = __webpack_public_path__ + "static/media/DZW_02.0ae6c4a5.jpg";